import Text from '../Common/NewText'
import { PrettyGreenButton } from '@/components/Stocks/TransactionSystem/PrettyBlueButton'
import { StencilCDNImage } from '@/components/Common/StencilImage'

const Disclaimer = ({ onClick }) => {
  return (
    <div className="flex items-center justify-between gap-x-8">
      <div
        title="Demat login"
        onClick={onClick}
        className="text-brand-blue-dark bg-brand-tertiary-blue flex flex-none cursor-pointer items-center rounded-[4px] px-2.5 py-1.5 text-xs"
      >
        <div className="flex h-[22px] w-[15px] items-center">
          <StencilCDNImage
            src="https://indcdn.indmoney.com/public/images/instocksbellicondelayedprice.png.png"
            width={15}
            height={15}
            alt="bell"
          />
        </div>
        <div className="ml-1 flex w-full items-center gap-1">
          <Text appearance="caption" tag="span">
            The current prices are delayed by 15 mins, login to check live
            prices.
          </Text>
          <Text
            appearance="caption"
            addClassName="text-brand-blue-azureRadiance"
            tag="button"
          >
            Login
          </Text>
        </div>
      </div>

      <PrettyGreenButton
        text="Start investing"
        paddingClassNames="py-2 px-5 !my-0"
        onClick={onClick}
      />
    </div>
  )
}

export default Disclaimer
